module.exports = __webpack_public_path__ + "static/media/3.cc3cce4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/3.wav
// module id = 00RK
// module chunks = 0